import { isAxiosError } from 'axios';
import { api } from '@/lib/api';

export interface DiretoriaErpFetchError {
  status: number;
  message: string;
}

export function extractDiretoriaErpError(error: unknown): DiretoriaErpFetchError {
  if (isAxiosError(error)) {
    const status = error.response?.status ?? 0;
    const body = error.response?.data as { message?: unknown; error?: unknown } | undefined;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : typeof body?.error === 'string'
          ? body.error
          : error.message || 'Erro ao consultar o ERP FlyStart.';
    return { status, message };
  }
  if (error instanceof Error) return { status: 0, message: error.message };
  return { status: 0, message: 'Erro ao consultar o ERP FlyStart.' };
}

/** Consulta um endpoint Diretoria/ERP; retorna null em 422/502/503 (erro operacional). */
export async function fetchDiretoriaErp<T>(
  path: string,
  companyId: string,
  dataFrom?: string,
  dataTo?: string,
  compareFrom?: string,
  compareTo?: string,
  extraParams?: Record<string, string | undefined>
): Promise<T | null> {
  try {
    const params = new URLSearchParams();
    if (companyId) params.append('companyId', companyId);
    if (dataFrom) params.append('dataFrom', dataFrom);
    if (dataTo) params.append('dataTo', dataTo);
    if (compareFrom) params.append('compareFrom', compareFrom);
    if (compareTo) params.append('compareTo', compareTo);
    if (extraParams) {
      for (const [k, v] of Object.entries(extraParams)) {
        if (v != null && v !== '') params.append(k, v);
      }
    }
    const qs = params.toString();
    const response = await api.get(`${path}${qs ? `?${qs}` : ''}`);
    return response.data.data as T;
  } catch (e: unknown) {
    const { status } = extractDiretoriaErpError(e);
    if ([422, 502, 503].includes(status)) return null;
    throw e;
  }
}

/** Probe leve para detectar falha de escopo ERP (coderp) ou SQL upstream. */
export async function probeDiretoriaErp(companyId: string): Promise<{ ok: true } | { ok: false; error: DiretoriaErpFetchError }> {
  try {
    const params = new URLSearchParams();
    if (companyId) params.append('companyId', companyId);
    const qs = params.toString();
    await api.get(`/reports/diretoria/motos-disponiveis${qs ? `?${qs}` : ''}`);
    return { ok: true };
  } catch (e: unknown) {
    const error = extractDiretoriaErpError(e);
    if ([422, 502, 503, 403].includes(error.status)) return { ok: false, error };
    throw e;
  }
}

export function parseCompanyCoderp(coderp?: string | null): number | null {
  const n = parseInt(String(coderp ?? '').trim(), 10);
  return Number.isInteger(n) && n > 0 ? n : null;
}
